import CsToolInboxHistoryScreen from './inbox-history';

export default CsToolInboxHistoryScreen;
